import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import LogoutConfirmationModal from "../modals/LogoutConfirmationModal";
import HttpRequest from "../../services/Request";
import { useParams } from "react-router-dom";

const Header = () => {
  const params = useParams();
  const username = Cookies.get("username");
  const [user_team, setUserTeam] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);

  useEffect(() => {
    HttpRequest(
      `${process.env.REACT_APP_DOMAIN}/get-header-data/${params.id}`,
      (res) => {
        setUserTeam(res.data.team_name);
        setCompanyLogo(res.data.company_logo);
      },
    );
  }, []);

  return (
    <>
      <div className="flex justify-around p-3 md:hidden">
        <img className="w-[25%]" src="/images/logo.png" />
      </div>
      <div className="flex md:hidden justify-between items-center">
        <div className={`flex`}>
          <img
            className="w-[70px] h-[70px] me-1 rounded"
            src={companyLogo}
            alt=""
          />
          <div className="flex flex-col justify-around ms-2">
            <p className="font-bold text-[16px] text-white">{user_team}</p>
            <p className="font-bold text-[16px] text-orange">{username}</p>
          </div>
        </div>
        <img
          onClick={() => setShowLogoutConfirmation(true)}
          className="w-[32px] h-[32px] mx-2 cursor-pointer"
          src="/icons/power.png"
        />
      </div>
      <div className="justify-around hidden md:flex mb-10">
        <div className="flex basis-2/6">
          <div className="flex justify-center items-center ms-2">
            <img
              className="w-[70px] h-[70px] mx-2 rounded"
              src={companyLogo}
              alt=""
            />
            <p className="font-bold text-[16px] text-white">{user_team}</p>
          </div>
        </div>
        <img className="w-[7%]" src="/images/logo.png" />
        <div className="flex basis-2/6 justify-end items-center">
          <img
            className="w-[64px] h-[64px]"
            src="/icons/user-desktop-logo.png"
          />
          <div className="flex flex-col justify-center ms-2">
            <p className="font-bold text-[16px] text-white">{username}</p>
          </div>
          <img
            onClick={() => setShowLogoutConfirmation(true)}
            className="w-[32px] h-[32px] mx-2 cursor-pointer"
            src="/icons/power.png"
          />
        </div>
      </div>
      <LogoutConfirmationModal
        handleSetOpen={(value) => setShowLogoutConfirmation(value)}
        open={showLogoutConfirmation}
      />
    </>
  );
};

export default Header;
